import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import Button from "../../Button";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const ManualModal = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [manualHtml, setManualHtml] = useState()

  useDidMountEffect(() => {
    apiUser.tecRmi.wiring.manualHtml({
      ...getApiPrimaryParams(),
      manualId: props.manualId,
      printView: false,
      kindOfWorkTime: 0,
      linkUrl: '',
    })
      .then(res => setManualHtml(res.data))
  })

  return <Modal isOpen className="modal-w-md-100 height-100vh" size={'xl'} toggle={props.onClose}>
    <ModalHeader toggle={props.onClose}>Instrukcje naprawcze</ModalHeader>
    <ModalBody>
      {
        manualHtml
          ? <div dangerouslySetInnerHTML={{__html: manualHtml}} />
          : <LoadingSpinner />
      }
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={props.onClose}>Zamknij</Button>
    </ModalFooter>
  </Modal>;
};

ManualModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  manualId: PropTypes.number.isRequired,
};

export default ManualModal;